import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useOrders } from '../contexts/OrderContext';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Truck, Calendar, MapPin, Package, CheckCircle2 } from 'lucide-react';
export function DriverToursPage() {
  const {
    user
  } = useAuth();
  const {
    tours
  } = useOrders();
  const navigate = useNavigate();
  const [filterStatus, setFilterStatus] = useState<'EN_COURS' | 'TERMINEE'>('EN_COURS');
  // Filter tours for current driver
  const myTours = tours.filter(t => t.driverId === user?.id);
  const filteredTours = myTours.filter(t => t.status === filterStatus);
  return <div className="space-y-6" data-id="element-499">
      <div className="flex justify-between items-center" data-id="element-500">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-501">Mes Tournées</h1>
      </div>

      {/* Tabs */}
      <div className="flex space-x-2 border-b border-gray-200 pb-1" data-id="element-502">
        <button onClick={() => setFilterStatus('EN_COURS')} className={`px-4 py-2 text-sm font-medium rounded-t-lg transition-colors ${filterStatus === 'EN_COURS' ? 'bg-white border-b-2 border-blue-500 text-blue-600' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-503">
          En Cours ({myTours.filter(t => t.status === 'EN_COURS').length})
        </button>
        <button onClick={() => setFilterStatus('TERMINEE')} className={`px-4 py-2 text-sm font-medium rounded-t-lg transition-colors ${filterStatus === 'TERMINEE' ? 'bg-white border-b-2 border-blue-500 text-blue-600' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-504">
          Terminées ({myTours.filter(t => t.status === 'TERMINEE').length})
        </button>
      </div>

      {/* List */}
      <div className="space-y-4" data-id="element-505">
        {filteredTours.length === 0 ? <Card className="bg-gray-50 border-dashed py-12 text-center" data-id="element-506">
            <Truck className="w-12 h-12 text-gray-300 mx-auto mb-4" data-id="element-507" />
            <p className="text-gray-500" data-id="element-508">
              Aucune tournée{' '}
              {filterStatus === 'EN_COURS' ? 'en cours' : 'terminée'}.
            </p>
          </Card> : filteredTours.map(tour => <Card key={tour.id} className={`hover:shadow-md transition-shadow cursor-pointer ${tour.status === 'TERMINEE' ? 'opacity-75' : 'border-l-4 border-l-blue-500'}`} data-id="element-509">
              <div onClick={() => navigate(`/driver/tours/${tour.id}`)} data-id="element-510">
                <div className="flex justify-between items-start mb-4" data-id="element-511">
                  <div data-id="element-512">
                    <div className="flex items-center gap-2 mb-2" data-id="element-513">
                      <span className={`px-2 py-1 text-xs font-bold rounded ${tour.type === 'LIVRAISON' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-514">
                        {tour.type}
                      </span>
                      <span className="text-xs text-gray-500 flex items-center" data-id="element-515">
                        <Calendar className="w-3 h-3 mr-1" data-id="element-516" />
                        {new Date(tour.date).toLocaleDateString('fr-FR')}
                      </span>
                    </div>
                    <h3 className="font-bold text-lg text-gray-900 flex items-center" data-id="element-517">
                      <MapPin className="w-4 h-4 mr-2 text-gray-400" data-id="element-518" />
                      {tour.zone}
                    </h3>
                  </div>
                  <div className="text-right" data-id="element-519">
                    <div className="text-2xl font-bold text-gray-900" data-id="element-520">
                      {tour.orderIds.length}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-521">Commandes</div>
                  </div>
                </div>

                <div className="flex items-center justify-between pt-4 border-t border-gray-100" data-id="element-522">
                  <div className="text-sm text-gray-600 flex items-center" data-id="element-523">
                    <Truck className="w-4 h-4 mr-2 text-gray-400" data-id="element-524" />
                    {tour.vehicle}
                  </div>
                  {tour.status === 'TERMINEE' && <span className="flex items-center text-green-600 text-sm font-medium" data-id="element-525">
                      <CheckCircle2 className="w-4 h-4 mr-1" data-id="element-526" /> Terminée
                    </span>}
                </div>
              </div>
            </Card>)}
      </div>
    </div>;
}